import React from 'react';
import { Link } from 'react-router-dom';
import failureImage from '../assets/images/failure-icon.gif';

const PaymentFailure = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center p-5 mt-4">
              <img
                src={failureImage}
                alt="Payment Failed"
                className="mb-4 mt-4"
                style={{ width: '100px' }}
              />
              <h2 className="text-danger mb-4">Payment Failed</h2>
              <p className="text-muted">
                We're sorry, but your payment could not be processed. Please try again or choose a different payment method.
              </p>
              <div className="mt-4">
                <Link to="/checkout" className="btn btn-primary me-2">
                  Try Again
                </Link>
                <Link to="/" className="btn btn-outline-primary">
                  Continue Shopping
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure; 